module.exports = __webpack_public_path__ + "static/media/avatar-100.0fa40fdb.svg";